<div class="container-fluid p-0 profile-page">
    <HeaderSection
        :breadcrumb="breadcrumb"
        @breadcrumb-click="handleBreadcrumbClick"
    />

    <section class="container profile-sections py-4">
        <SettingsUserManagementTab :user_profile="user_profile" />
    </section>
</div>
